import { computed } from 'vue'
import { useUserStore } from '../stores/userStore'

export type FeatureFlag =
  | 'language-switcher'
  | 'asset-level-user-permission'
  | 'carbon-value-at-risk'
  | 'carbon-savings-by-year'
  | 'input-portal-meter-filters'
  | 'building-units-new-input-portal'
  | 'building-units-import-export'
  | 'building-units-analytics-page'
  | 'new-create-survey-page'
  | 'mappings-page'
  | 'draft-meters'
  | 'landlord-tenant-breakdown'
  | 'energy-spend-intensity'
  | 'asset-roadmap-details'
  | 'gresb-ignore-ownership-date-filter'
  | 'gresb-estimation-mode'
  | 'ai-asset-summary'
  | 'ai-chart-analysis'
  | 'ai-chatbot'
  | 'ai-chat-history'
  | 'ai-asset-list-table'
  | 'ai-data-quality-table'
  | 'ai-forecast-meter-consumption'
  | 'asset-meter-analytics'
  | 'consumption-coverage'
  | 'custom-dashboards-page'
  | 'custom-graphs'
  | 'asset-details-page'
  | 'physical-climate-portfolio-page'
  | 'physical-climate-asset-list-page'
  | 'ai-gresb-score-analysis'
  | 'new-homepage'
  | 'ai-roadmap-measure-completion'
  | 'custom-scores'
  | 'new-portfolio-regulatory-page'
  | 'show-portfolio-regulatory-page'
  | 'portfolio-esg-data-page'
  | 'portfolio-roadmap-page'
  | 'input-asset-roadmap-page'
  | 'asset-roadmap-page'
  | 'input-portfolio-roadmap-page'
  | 'portfolio-scores-page'
  | 'ai-roadmap-measure'
  | 'data-request-feature'
  | 'import-export-data-request'
  | 'bill-scraping'
  | 'automation-settings-page'
  | 'enable-metrics-table-column-reordering'
  | 'enable-metrics-table-row-reordering'
  | 'enable-metrics-table-add-row-or-column'
  | 'fiscal-year-calculations'
  | 'ai-paid-plan'
  | 'download-charts'
  | 'physical-climate-measures'
  | 'asset-esg-data-page'
  | 'asset-scores-page'
  | 'use-estimated-data-for-analytics-charts'
  | 'calculated-meters'
  | 'granular-data'
  | 'financial-data-access-switcher'
  | 'ai-data-collection'
  | 'new-collection-asset-list-page'
  | 'asset-groups'
  | 'company-level-asset-list-page'
  | 'collection-report-filters-cleaner-design'
  | 'share-custom-dashboard'
  | 'portfolio-performance-page'
  | 'portfolio-financial-dashboard'
  | 'custom-fields'
  | 'portfolio-alerts-table'
  | 'roadmaps-refactor'
  | 'portfolio-data-completion-banner'
  | 'onboarding-checklist'
  | 'ai-ddq-response-generator'
  | 'governance-dev-indicator'
  | 'sidebar-favorites'
  | 'reports-section'
  | 'new-audit-system'
  | 'data-lock-mechanism'
  | 'bps-overview-page'
  | 'risk-resilience-page'
  | 'floor-coverage-settings'
  | 'partial-calculation-status-ui'
  | 'formula-fields'
  | 'optimized-meters-loading'
  | 'optimized-input-portal-loading'
  | 'input-portal-bootstrap'
  | 'ai-meter-analysis'
  | 'ai-meter-setup-analysis'

export default function useCanAccessFeature(feature: FeatureFlag) {
    const hasAccess = computed(() => canAccessFeature(feature))
    return { hasAccess, canAccessFeature }
}

export function canAccessFeature(feature: FeatureFlag): boolean {
    if (feature === 'bps-overview-page') {
        return true
    }
    return (
        useUserStore()?.authUser()?.feature_flags?.includes(feature) ?? false
    )
}
